var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"disabled":!_vm.visible,"color":"secondary","outlined":"","small":"","loading":_vm.loading},on:{"click":function($event){return _vm.handler()}}},[_c('span',{staticClass:"text-notransform"},[_vm._v("Close")])])
}
var staticRenderFns = []

export { render, staticRenderFns }